var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcBinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#F3BA2F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.728 9.245 11 4.973l4.278 4.274 2.486-2.486L11 0 4.242 6.759l2.486 2.486ZM2.486 8.514 4.972 11l-2.486 2.486L0 11l2.486-2.486ZM6.728 12.757 11 17.029l4.275-4.272 2.487 2.485-6.761 6.761-6.759-6.758 2.486-2.488ZM22.001 11.001l-2.486 2.486-2.486-2.486 2.486-2.486L22 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.523 10.996-2.522-2.52-1.864 1.864-.214.214-.442.442 2.52 2.52 2.523-2.523-.001.003Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBinance);
export default __webpack_public_path__ + "static/media/ic_binance.60a43ade662a49eb0a6fcc7550541da4.svg";
export { ForwardRef as ReactComponent };